import React from 'react';
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import {useDispatch, useSelector, useStore} from "react-redux";
import {makeStyles} from "@material-ui/core";
import ScrollableAnchor from "react-scrollable-anchor";
import Radio from "@material-ui/core/Radio";
import clsx from "clsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import {DropzoneArea} from "material-ui-dropzone";
import {setBizFile} from "../../modules/file";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
    answerState,
    bizFileState,
    menuCheckSelector,
    selectedMenuItemState,
    surveyDataState, userState
} from "../../state/globalState";
import DropzoneFileItem from "../common/DropzoneFileItem";
import {fileUploadToAzureStorage, findFilesByFileGcd} from "../../lib/api/file";

const useStyles = makeStyles(theme => ({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#1b6817',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#1b6817',
        },
    },
    textField: {
        width: 300
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

/**
 * 설문 문항 컴포넌트
 */
const Survey11 = (props) => {
    const userInfo = useRecoilValue(userState);
    const surveyData = useRecoilValue(surveyDataState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const [bizFiles, setBizFiles] = useRecoilState(bizFileState);
    const classes = useStyles();
    const bizYn = answer.bizYn;

    const getFiles = async (admnNo, stdYear) => {
        const { data } = await findFilesByFileGcd(admnNo, stdYear);
        if (data.success) {
            const files = data.payload.filter((file) => (file.kognrFileGcd === "HC050002"))
            setBizFiles(files);
        }
    }

    const handleInputAnswer = (e, column) => {
        const { value } = e.target;

        setAnswer({
            ...answer,
            [column]: value
        });

        setSelectedMenuItem('SURVEY_28');
        setMenuCheck(value !== '');
    };

    const StyledRadio = (props) => {
        return (
            <Radio
                disableRipple
                color="default"
                checked={bizYn === props.value}
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={(e) => handleInputAnswer(e, 'bizYn')}
                {...props}
            />
        );
    };

    const step28List = surveyData[28].text.map((item) => {
        // item.content = item.content.replace('$stdYear$', appStore.getState().user.userInfo.stdYear);

        return (
            <>
                <FormControlLabel key={'28-' + item.key} name={String(item.toggle)} value={item.key}
                                  control={<StyledRadio />} label={item.content}/>
            </>
        )
    });

    const handleChange = async (files) => {
        if (!files || files.length === 0) return;

        const opts = {
            stdYear: userInfo.stdYear,
            admnNo: userInfo.admnNo,
            attcFileBizGcd: "hc056002",
            kognrFileGcd: "HC050002",
        }

        for (const fileObj of files) {
            const { data } = await fileUploadToAzureStorage(fileObj, opts);
            if (data.success) {
                const { resultCode, resultMsg } = data.payload;
                if (resultCode === "0000") {
                    setMenuCheck(true);
                } else {
                    console.error("File upload failed:", resultMsg);
                }
            }
        }

        await getFiles(userInfo.admnNo, userInfo.stdYear);
    };

    return (
        <>
            <ScrollableAnchor id={"28"}>
                <div>
                <Container style={{background: 'transparent', marginBottom: '10px'}}>
                    <SentenceForm
                        title={surveyData[28].title}
                        sentences={surveyData[28].questions}
                        step={28}
                    />
                    {bizYn === '1' && (
                        <div>
                            {/*<div className="blockquote-box">*/}
                            {/*    <div>*/}
                            {/*        사업소득 파일 업로드 안내 문구*/}
                            {/*    </div>*/}
                            {/*    <div>*/}
                            {/*        파일형식 : 이미지파일, PDF파일, Excel 파일*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <br/>
                            <div style={{marginLeft: '25px'}}>
                                <DropzoneArea
                                    acceptedFiles={[
                                        'application/pdf',
                                        'image/jpeg',
                                        'image/png',
                                        'application/vnd.ms-excel',
                                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                        'application/msword',
                                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                        'application/zip',
                                        '.hwp'
                                    ]}
                                    filesLimit={20}
                                    dropzoneText={'파일을 선택하거나 또는 여기로 끌어 주세요.'}
                                    maxFileSize={30000000}
                                    // showFileNames={true}
                                    showPreviewsInDropzone={false}
                                    showAlerts={false}
                                    onDrop={handleChange}
                                    // onDelete={handleDelete}
                                    // initialFiles={bizFile && bizFile.map((file) => file.name)}
                                />
                                {bizFiles && bizFiles.map((file) => <DropzoneFileItem {...file} />)}
                            </div>
                        </div>
                    )}
                    <FormControl component="fieldset" style={{margin: '10px 20px 0 25px'}}>
                        {/*<Divider />*/}
                        <RadioGroup defaultValue="0" aria-label="" name="" row>
                            {step28List}
                        </RadioGroup>
                        {/*<Divider />*/}
                    </FormControl>
                </Container>
                </div>
            </ScrollableAnchor>
        </>
    );
};

export default Survey11;
